import { BaseModel } from './BaseModel';
import User from './User';
import OrderItem from './OrderItem';
import Payment from './Payment';

export class Order extends BaseModel {
  static get entity() {
    return 'orders';
  }
  static get fk() {
    return 'order_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      user_id: this.attr(null),
      user: this.belongsTo(User, 'user_id'),
      order_item_ids: this.attr([]),
      order_items: this.hasManyBy(OrderItem, 'order_item_ids'),
      payment_ids: this.attr([]),
      payments: this.hasManyBy(Payment, 'payment_ids'),
      latest_payment_id: this.attr(null),
      latest_payment: this.belongsTo(Payment, 'latest_payment_id'),
      count_items: this.attr(null),
      status: this.attr(null),
      total_price: this.attr(null),
      total_discount: this.attr(null),
      payment_method: this.attr(null),
      total_amount: this.attr(null),
      order_no: this.attr(null),
      updated_at: this.attr(null),
      created_at: this.attr(null)
    };
  }
  static apiConfig = {
    actions: {
      async fetchWithPagination(params = {}, save = false) {
        const {
          response: { data = [] }
        } = await this.get(`/orders`, { params, save });
        if (data && data.orders.length && data.orders) {
          await Order.insert({
            data: data.orders
          });
        }
        return data;
      },
      fetchOrder(id) {
        return this.get(`/orders/${id}`);
      },
      renewPayment(id) {
        return this.put(`/orders/${id}/renew-payment`);
      },

      async checkout(body = {}) {
        const { response } = await this.put(`/orders/checkout`, body);

        const { data } = response;

        const op = await Order.create({ data });

        return op.orders[0];
      }
    }
  };
}

export default Order;
